import { useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Target,
  Users,
  Award,
  MoreHorizontal,
} from "lucide-react";

const navItems = [
  { id: "dashboard", label: "Home", icon: LayoutDashboard, path: "/dashboard" },
  { id: "evaluate", label: "Avaliar", icon: Target, path: "/evaluate", accent: true },
  { id: "players", label: "Jogadores", icon: Users, path: "/players" },
  { id: "ranking", label: "Ranking", icon: Award, path: "/ranking" },
];

export function BottomNav({ onOpenMenu }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-border bg-card/95 backdrop-blur-xl safe-area-bottom"
      data-testid="bottom-nav"
    >
      <div className="flex items-stretch justify-around h-14">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              data-testid={`bottom-nav-${item.id}`}
              className={`flex-1 flex flex-col items-center justify-center gap-0.5 transition-colors relative ${
                active
                  ? item.accent
                    ? "text-[hsl(var(--highlight))]"
                    : "text-primary"
                  : "text-muted-foreground active:text-foreground"
              }`}
            >
              {active && (
                <span
                  className={`absolute top-0 left-1/2 -translate-x-1/2 h-0.5 w-6 rounded-full ${
                    item.accent ? "bg-[hsl(var(--highlight))]" : "bg-primary"
                  }`}
                />
              )}
              <Icon className="h-5 w-5" strokeWidth={active ? 2.5 : 1.8} />
              <span className="text-[10px] font-medium leading-none">{item.label}</span>
            </button>
          );
        })}

        {/* More / Menu button */}
        <button
          onClick={onOpenMenu}
          data-testid="bottom-nav-menu"
          className="flex-1 flex flex-col items-center justify-center gap-0.5 text-muted-foreground active:text-foreground transition-colors"
        >
          <MoreHorizontal className="h-5 w-5" strokeWidth={1.8} />
          <span className="text-[10px] font-medium leading-none">Menu</span>
        </button>
      </div>
    </nav>
  );
}
